import { IAvailableRating } from '../../types/rating';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import {
  EFiltersActionTypes,
  TClearFilters,
  TSetRatingFilters,
  TSetTagsFilters,
  TToggleRatingFilterType,
  TToggleTagFilterType,
} from './types';
import { ITag } from '../../types/tag';

export const toggleRatingFilter: (payload: number) => TToggleRatingFilterType = actionGenerator<
  EFiltersActionTypes.ToggleRatingFilter,
  number
>(EFiltersActionTypes.ToggleRatingFilter);

export const setRatingFilters: (payload: IAvailableRating[]) => TSetRatingFilters = actionGenerator<
  EFiltersActionTypes.SetRatingFilters,
  IAvailableRating[]
>(EFiltersActionTypes.SetRatingFilters);

export const toggleTagFilter: (payload: string) => TToggleTagFilterType = actionGenerator<
  EFiltersActionTypes.ToggleTagFilter,
  string
>(EFiltersActionTypes.ToggleTagFilter);

export const setTagFilters: (payload: ITag[]) => TSetTagsFilters = actionGenerator<
  EFiltersActionTypes.SetTagFilters,
  ITag[]
>(EFiltersActionTypes.SetTagFilters);

export const clearFilters: () => TClearFilters = actionGenerator<EFiltersActionTypes.ClearFilters>(
  EFiltersActionTypes.ClearFilters,
);
